import { addLocale, useLocales } from 'ttag';
import { SUPPORTED_LANGUAGES } from '../constants/languages';

export const SATFARM_LANGUAGE = 'satfarm-language';
export const DEFAULT_LANG = 'de';

export const changeLanguage = (locale) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useLocales([`satfarm-${locale}`]);
  saveLang(locale);
};

export const getLanguage = () => {
  const storedLang = localStorage.getItem(SATFARM_LANGUAGE);
  if (!storedLang) {
    saveLang(DEFAULT_LANG);
    return DEFAULT_LANG;
  }
  return storedLang;
};

const saveLang = (locale) => {
  localStorage.setItem(SATFARM_LANGUAGE, locale);
};

export const initLanguages = () => {
  SUPPORTED_LANGUAGES.forEach((locale) => {
    const ttagObject = require(`../translations/${locale.langCode}.po.json`);
    if (process.env.REACT_APP_DEBUG_TRANSLATIONS === 'true') {
      makeDebugTranslations(ttagObject);
    }

    addLocale(`satfarm-${locale.langCode}`, ttagObject);
  });
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useLocales([`satfarm-${getLanguage()}`]);
};

function makeDebugTranslations(ttagObject) {
  const translations = ttagObject.translations[''];
  for (let key in translations) {
    if (translations[key].msgid.length === 0) {
      continue;
    }
    translations[key].msgstr = translations[key].msgstr.map((str) =>
      replaceStringWithXs(str === '' ? key : str),
    );
  }
}

function replaceStringWithXs(str) {
  const PERCENTAGE_OF_LENGTH = 80;
  let newStrArr = [];
  const newStrLength = Math.ceil(str.length * (PERCENTAGE_OF_LENGTH / 100));
  for (let i = 0; i <= newStrLength; i++) {
    newStrArr.push('x');
  }
  return newStrArr.join('');
}
